module.exports = __webpack_public_path__ + "img/hero-presents-collage@2x.04d8e822.png";